<template>
  <footer id="footer" class="footer" role="contentinfo">
    <section>
      <SocialLinks v-if="isDesktop"></SocialLinks>
      <FooterMenuComponent :footerMenu="items" :property="property"></FooterMenuComponent>

    </section>
    <!-- <div id="footer-menu" class="container">
      &copy; {{ copyrightYear }} {{ property.name }}

    </div> -->

    <section id="copyright">
      <div class="copyright container">
        &copy; {{ copyrightYear }} {{ property.name }}

      </div>
    </section>
  </footer>
  
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useMainStore } from "~/store/index";
import dayjs from 'dayjs';

const store = useMainStore();
const { isMobile, isDesktop } = useMobileChecker();

// PROPS
const props = defineProps(["items", "property", "isMobile", "socialMedia" ]);
const copyrightYear = computed(() => dayjs().year());
</script>

<style lang="scss" scoped>
#footer {
  
  
  
  
  #copyright {
    background-color: #f7f7f7;
    font-family: 'system-ui,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif';
    letter-spacing: 1.5px;
    font-size: 12px;
    text-transform: uppercase;
    padding: 0;
    margin: 0;
    height: 60px;
    line-height: 60px;

    .copyright {
      background-color: #f7f7f7;
      margin: 0 auto;
      max-width: 1259px;
      font-size: 11px;
      font-family: $font_poppin;
      text-transform: uppercase;
      letter-spacing: 1.5px;
    }

    @media only screen and (max-width: 1024px) {
      color: $white;
      .copyright {
        background-color: $black;
        display: flex;
        justify-content: center;
      }

    }
  }

}

</style>